import { FlexBox, Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const SwitcherWrapper = styled(FlexBox)<{ importantBG: boolean }>`
    width: ${LayoutConst.projectCard.l.w * 3 + LayoutConst.projectCardGap.l * 2}px;
    max-width: ${LayoutConst.projectCard.l.w * 3 + LayoutConst.projectCardGap.l * 2}px;
    min-width: ${LayoutConst.projectCard.l.w * 3 + LayoutConst.projectCardGap.l * 2}px;
    height: auto;
    background-color: transparent;
    flex-flow: row;
    margin-top: 32px;

    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin-top: 24px;
        height: auto;
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${LayoutConst.projectCard.m.w * 3 + LayoutConst.projectCardGap.m * 2}px;
        max-width: ${LayoutConst.projectCard.m.w * 3 + LayoutConst.projectCardGap.m * 2}px;
        min-width: auto;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: ${LayoutConst.projectCard.xs.w * 3  + LayoutConst.projectCardGap.tablet * 2}px;
        max-width: ${LayoutConst.projectCard.xs.w * 3  + LayoutConst.projectCardGap.tablet * 2}px;
        min-width: ${LayoutConst.projectCard.xs.w * 3  + LayoutConst.projectCardGap.tablet * 2}px;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        margin-top: 32px;
        width: 100%;
        max-width: none;
        min-width: auto;
        height: 24px;
        flex-wrap: wrap;

        > :not(:first-child) {
            margin-left: 0;
        }
    }
`;

export const SwitchItem = styled.div<{ isActive: boolean }>`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: 0,02em;
    color: ${({ theme }) => theme.tagAdminPage.switcher?.item?.color};
    transition: color 0.2s;
    cursor: pointer;

    svg {
        width: 8px;
        height: 8px;
        margin-left: 4px;
    }

    svg path {
        fill: ${({ theme }) => theme.tagAdminPage?.switcher?.item?.color};
        transition: fill 0.2s;
    }


    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    ${({ isActive, theme }) => isActive && css`
        color: ${theme.tagAdminPage?.switcher?.item?.hoverColor};
        transition: color 0.2s;

        svg path {
            fill: ${theme.tagAdminPage?.switcher?.item?.hoverColor};
            transition: fill 0.2s;
        }
    `};

    :hover {
        color: ${({ theme }) => theme.tagAdminPage?.switcher?.item?.hoverColor};
        transition: color 0.2s;

        svg path {
            fill: ${({ theme }) => theme.tagAdminPage.switcher?.item?.hoverColor};
            transition: fill 0.2s;
        }
    }

    @media (max-width: ${LayoutConst.screen.l_12 }px) {
        font-size: 13px;
        line-height: 16px;
        white-space: nowrap;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        height: 20px;
    }
`;

export const MobileSortBar = styled(FlexBox)<{ disableOffset?: boolean }>`
    height: 25px;
    @media(max-width: ${LayoutConst.screen.m}px) {
        ${({ disableOffset }) => disableOffset && css`
            margin: 0 !important;
        `};
        svg {
            height: 18px;
        }
    }
`;

export const TagsContainer = styled(FlexBox)<{ isFtbl?: boolean }>`
    display: ${({ isFtbl }) => isFtbl ? 'none' : 'flex'};
    position: relative;
    flex-wrap: wrap;
    gap: 4px 0;
    div {
        &:hover {
            color: ${({ theme }) => theme.tagAdminPage?.switcher?.item?.hoverColor} !important;
        }
    }
    & > *:not(:last-child){
        margin-right: 24px;
    }
     @media(max-width: ${LayoutConst.screen.m}px) {
        & > *:not(:last-child){
            margin-right: 4px;
        }
     }  
`

export const TagTitleWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`

export const TagTitleText = styled.div`
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    color: #909090;

    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;

    svg {
        width: 9px;
        margin-left: 4px;
        margin-bottom: 2px;
    }

    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

`
export const TagArrowIcon = styled.div`
    display: flex;
    align-items: center;
    
    svg path {
        transition: fill 0.3s ease;
    }
`;

export const TagWrapper = styled(FlexBox)`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &:hover {
        & > ${TagTitleText}, & > ${TagArrowIcon} svg path {
            color: #909090;
            fill: #909090;
            transition: fill 0.3s ease, color 0.3s ease;
        }
    }
`;

export const DescriptionContainer = styled(FlexBox)<{ importantStyles?: boolean }>`
    flex-flow: column;
`;

export const CustomShowMoreContainer = styled.div<{ isDark?: boolean }>`
    .show-more-container {
        width: 100%;
        font-family: 'Inter';
    }
  
  .show-more-text {
    margin: 0;
    font-size: 20px;
    line-height: 28px;
    overflow: hidden;
    transition: max-height 0.3s ease;
    white-space: pre-wrap;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.sendProjectsModal.title};
  }

  .show-more-text.collapsed {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .show-more-button {
    background: none;
    border: none;
    outline: none;
    color: rgb(205, 205, 205);
    cursor: pointer;
    font-size: 20px;
    line-height: 28px;
    display: inline-flex;
    align-items: center;
    vertical-align: baseline;
  }
  
  .show-more-button:hover {
    color: #151514;

    ${p => p.isDark ?
        css`
            color: ${Colors.geoWhite100};
        ` : css`
            color: #151514;
    `};
  }

  .show-more-button:focus {
    outline: none;
  }

  .show-more-wrapper {
    display: inline;
    white-space: nowrap;
  }
  
  .ellipsis {
    font-size: 16px;
    color: #000;
    vertical-align: baseline;
  }
  
  .show-more-text p {
    margin: 0 0 10px;
  }

    .show-more-text p:last-child {
        margin-bottom: 0;
    }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    .show-more-text, .show-more-button {
        font-size: 17px;
        line-height: 22px;
    }
  }
`;import { FlexBox, Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const SwitcherWrapper = styled(FlexBox)<{ importantBG: boolean }>`
    width: ${LayoutConst.projectCard.l.w * 3 + LayoutConst.projectCardGap.l * 2}px;
    max-width: ${LayoutConst.projectCard.l.w * 3 + LayoutConst.projectCardGap.l * 2}px;
    min-width: ${LayoutConst.projectCard.l.w * 3 + LayoutConst.projectCardGap.l * 2}px;
    height: auto;
    background-color: transparent;
    flex-flow: row;
    margin-top: 32px;

    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        margin-top: 24px;
        height: auto;
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${LayoutConst.projectCard.m.w * 3 + LayoutConst.projectCardGap.m * 2}px;
        max-width: ${LayoutConst.projectCard.m.w * 3 + LayoutConst.projectCardGap.m * 2}px;
        min-width: auto;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: ${LayoutConst.projectCard.xs.w * 3  + LayoutConst.projectCardGap.tablet * 2}px;
        max-width: ${LayoutConst.projectCard.xs.w * 3  + LayoutConst.projectCardGap.tablet * 2}px;
        min-width: ${LayoutConst.projectCard.xs.w * 3  + LayoutConst.projectCardGap.tablet * 2}px;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        margin-top: 32px;
        width: 100%;
        max-width: none;
        min-width: auto;
        height: 24px;
        flex-wrap: wrap;

        > :not(:first-child) {
            margin-left: 0;
        }
    }
`;

export const SwitchItem = styled.div<{ isActive: boolean }>`
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: 0,02em;
    color: ${({ theme }) => theme.tagAdminPage.switcher?.item?.color};
    transition: color 0.2s;
    cursor: pointer;

    svg {
        width: 8px;
        height: 8px;
        margin-left: 4px;
    }

    svg path {
        fill: ${({ theme }) => theme.tagAdminPage?.switcher?.item?.color};
        transition: fill 0.2s;
    }


    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    ${({ isActive, theme }) => isActive && css`
        color: ${theme.tagAdminPage?.switcher?.item?.hoverColor};
        transition: color 0.2s;

        svg path {
            fill: ${theme.tagAdminPage?.switcher?.item?.hoverColor};
            transition: fill 0.2s;
        }
    `};

    :hover {
        color: ${({ theme }) => theme.tagAdminPage?.switcher?.item?.hoverColor};
        transition: color 0.2s;

        svg path {
            fill: ${({ theme }) => theme.tagAdminPage.switcher?.item?.hoverColor};
            transition: fill 0.2s;
        }
    }

    @media (max-width: ${LayoutConst.screen.l_12 }px) {
        font-size: 13px;
        line-height: 16px;
        white-space: nowrap;
    }

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        height: 20px;
    }
`;

export const MobileSortBar = styled(FlexBox)<{ disableOffset?: boolean }>`
    height: 25px;
    @media(max-width: ${LayoutConst.screen.m}px) {
        ${({ disableOffset }) => disableOffset && css`
            margin: 0 !important;
        `};
        svg {
            height: 18px;
        }
    }
`;

export const TagsContainer = styled(FlexBox)<{ isFtbl?: boolean }>`
    display: ${({ isFtbl }) => isFtbl ? 'none' : 'flex'};
    position: relative;
    flex-wrap: wrap;
    gap: 4px 0;
    div {
        &:hover {
            color: ${({ theme }) => theme.tagAdminPage?.switcher?.item?.hoverColor} !important;
        }
    }
    & > *:not(:last-child){
        margin-right: 24px;
    }
     @media(max-width: ${LayoutConst.screen.m}px) {
        & > *:not(:last-child){
            margin-right: 4px;
        }
     }  
`

export const TagTitleWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`

export const TagTitleText = styled.div`
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    color: #909090;

    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;

    svg {
        width: 9px;
        margin-left: 4px;
        margin-bottom: 2px;
    }

    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

`
export const TagArrowIcon = styled.div`
    display: flex;
    align-items: center;
    
    svg path {
        transition: fill 0.3s ease;
    }
`;

export const TagWrapper = styled(FlexBox)`
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &:hover {
        & > ${TagTitleText}, & > ${TagArrowIcon} svg path {
            color: #909090;
            fill: #909090;
            transition: fill 0.3s ease, color 0.3s ease;
        }
    }
`;

export const DescriptionContainer = styled(FlexBox)<{ importantStyles?: boolean }>`
    flex-flow: column;
`;

export const CustomShowMoreContainer = styled.div<{ isDark?: boolean }>`
    .show-more-container {
        width: 100%;
        font-family: 'Inter';
    }
  
  .show-more-text {
    margin: 0;
    font-size: 20px;
    line-height: 28px;
    overflow: hidden;
    transition: max-height 0.3s ease;
    white-space: pre-wrap;
    letter-spacing: -0.02em;
    color: ${({ theme }) => theme.sendProjectsModal.title};
  }

  .show-more-text.collapsed {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .show-more-button {
    background: none;
    border: none;
    outline: none;
    color: rgb(205, 205, 205);
    cursor: pointer;
    font-size: 20px;
    line-height: 28px;
    display: inline-flex;
    align-items: center;
    vertical-align: baseline;
  }
  
  .show-more-button:hover {
    color: #151514;

    ${p => p.isDark ?
        css`
            color: ${Colors.geoWhite100};
        ` : css`
            color: #151514;
    `};
  }

  .show-more-button:focus {
    outline: none;
  }

  .show-more-wrapper {
    display: inline;
    white-space: nowrap;
  }
  
  .ellipsis {
    font-size: 16px;
    color: #000;
    vertical-align: baseline;
  }
  
  .show-more-text p {
    margin: 0 0 10px;
  }

    .show-more-text p:last-child {
        margin-bottom: 0;
    }

  @media(max-width: ${LayoutConst.screen.l_12}px) {
    .show-more-text, .show-more-button {
        font-size: 17px;
        line-height: 22px;
    }
  }
`;